<form [formGroup]="form" (ngSubmit)="onSubmit()" novalidate [style.backgroundImage]="'url('+ getRandomBackground() +')'">
    <div fxLayout="row" fxLayoutAlign="center center" [class.loading]="loading">
        <mat-card class="elevated">
            <mat-card-title>
                <div class="center title">
                    <img src="assets/logo_.png" alt="Logo" id="header-logo" class="center">
                    <p class="center title-text">Inloggen bij de DLA Access monitor</p>
                </div>
            </mat-card-title>
            <mat-card-content>
                <div class="center content">
                    <p>
                        <span class="error-message" *ngIf="error">
                            <mat-icon>error_outline</mat-icon> {{error}}
                        </span>
                    </p>
                    <!-- name -->
                    <p>
                        <mat-form-field class="login-form-field">
                            <input matInput placeholder="E-mail adres" formControlName="Name">
                        </mat-form-field>
                    </p>

                    <!-- password -->
                    <p>
                        <mat-form-field class="login-form-field">
                            <input type="password" placeholder="Wachtwoord" matInput formControlName="Password">
                        </mat-form-field>
                        <a class="forgot-password" (click)="openForgotPasswordDialog()">Heeft u geen toegang tot uw account?</a>
                    </p>

                    <button class="submit-button" mat-flat-button type="submit" color="primary" [disabled]="!form.valid || form.pristine">Login</button>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
</form>

<div class="loader" *ngIf="loading" fxLayout="row" fxLayoutAlign="center center">
    <mat-spinner [mode]="'indeterminate'">
    </mat-spinner>
</div>